export default {
  "404-layout": () => import("/insocial-landing/layouts/404Layout.vue"),
  "blog-layout": () => import("/insocial-landing/layouts/BlogLayout.vue"),
  "default-layout": () => import("/insocial-landing/layouts/DefaultLayout.vue")
}